// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--caPuj","image":"_7a3fb80146--image--MzU09","message":"_7a3fb80146--message--oVZ_W","button-wrapper":"_7a3fb80146--button-wrapper--pLBjp"};